/* src/app/shared/components/event-list/calendar-month-scroller/calendar-month-scroller.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.calendar-month-scroller {
  background-color: white;
  font-size: 1rem;
}
.calendar-month-scroller .months {
  padding: 0;
  list-style-type: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  overflow-x: hidden;
  margin: 0 0 0.25em 0;
  border-top: solid thin #e8e8e6;
  border-bottom: solid thin #e8e8e6;
}
.calendar-month-scroller .months .month {
  width: 24%;
}
.calendar-month-scroller .months .month.all {
  position: relative;
}
.calendar-month-scroller .months .month.all::after {
  content: "";
  width: 1px;
  height: 1.125em;
  border-right: solid thin #979797;
  position: absolute;
  top: 0.875em;
  right: 0;
}
.calendar-month-scroller .months .month.all .mat-mdc-raised-button {
  color: #004791;
}
.calendar-month-scroller .months .month.active .mat-mdc-raised-button {
  font-weight: 700;
}
.calendar-month-scroller .months .month .mat-mdc-raised-button {
  font-size: 0.8125em;
  letter-spacing: 0.5px;
  font-weight: 500;
  min-width: 0;
  width: 100%;
  color: #242424;
  border-radius: 0;
  padding: 0;
}
.divider.vertical {
  flex: 0 0 1px;
  height: 1.125em;
  border-right: solid thin #979797;
}
/*# sourceMappingURL=calendar-month-scroller.component.css.map */
